import { Link } from 'react-router-dom';
import { Building, ExternalLink, ShieldCheck } from 'lucide-react';

export default function VendorCard({ vendor, entryVendor }) {
    const name = entryVendor || vendor?.name || 'Unknown Vendor';
    const country = vendor?.country || '';
    const represented = vendor?.represented || vendor?.is_represented || false;
    const vendorId = vendor?.id;

    return (
        <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '1rem',
            background: 'var(--bg-tertiary)',
            border: '1px solid var(--border)',
            borderRadius: '8px',
            padding: '1rem',
        }}>
            <div style={{
                background: 'var(--gold-light)',
                borderRadius: '50%',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
            }}>
                <Building size={20} color="var(--gold)" />
            </div>
            <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <h4 style={{ margin: 0, color: 'var(--text-primary)', fontSize: '1rem' }}>
                        {name}
                    </h4>
                    {represented && (
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.2rem',
                            background: 'rgba(100,255,218,0.1)',
                            color: 'var(--success)',
                            fontSize: '0.65rem',
                            fontWeight: 600,
                            padding: '0.1rem 0.4rem',
                            borderRadius: '3px',
                            textTransform: 'uppercase',
                        }}>
                            <ShieldCheck size={10} /> Represented
                        </span>
                    )}
                </div>
                {country && (
                    <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.5rem' }}>
                        Country: {country}
                    </div>
                )}
                {vendorId && (
                    <Link
                        to={`/lexis/vendors?id=${vendorId}`}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            color: 'var(--gold)',
                            fontSize: '0.8rem',
                            textDecoration: 'none',
                        }}
                    >
                        View vendor profile <ExternalLink size={10} />
                    </Link>
                )}
            </div>
        </div>
    );
}